'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStore;

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStore(history, data) {
    // Sync dispatched route actions to the history
    var reduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);

    var sagaMiddleware = (0, _reduxSaga2.default)();
    var middleware = [reduxRouterMiddleware, sagaMiddleware];

    var finalCreateStore = void 0;
    if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
        var _require = require('redux-devtools'),
            persistState = _require.persistState;

        var DevTools = require('../containers/DevTools/DevTools');

        finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
    } else {
        finalCreateStore = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
    }

    var reducer = require('./modules/root').default;

    var store = finalCreateStore(reducer, data);

    if (__DEVELOPMENT__ && module.hot) {
        module.hot.accept('./modules/root', function () {
            store.replaceReducer(require('./modules/root').default);
        });
    }

    store.runSaga = sagaMiddleware.run;
    store.close = function () {
        return store.dispatch(_reduxSaga.END);
    };

    return store;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/create.js
// module id = 1653
// module chunks = 0